import { useTheme } from "@mui/material";

function BuoyIcon({ addBuoy, color, size }: { addBuoy?: boolean; color?: string; size?: number }) {
	const theme = useTheme();

	return (
		<svg width={size ?? 20} height={size ?? 20} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M17.281 48.974C15.362 28.767 1 16.383 1 16.383V10.618L12.209 1H29.009L40.218 10.618V16.383C40.218 16.383 25.857 28.767 23.937 48.974H17.281Z"
				stroke={color ?? theme.palette.primary.main}
				strokeWidth="3"
			/>
			<path d="M1.31201 10.617H40.534" stroke={color ?? theme.palette.primary.main} strokeWidth="3" />
			{addBuoy && (
				<path
					d="M49.2871 37.1782V39.812H34.1807V37.1782H49.2871ZM43.1416 30.7451V46.79H40.3413V30.7451H43.1416Z"
					fill={color ?? theme.palette.primary.main}
				/>
			)}
		</svg>
	);
}

export default BuoyIcon;
